<template>
  <div v-if="isOpen" class="modal-overlay">
    <div class="modal-content">
      <p class="modal-title">Только для специалистов здравоохранения</p>
      <p class="modal-text">
        Информация предназначена исключительно для специалистов здравоохранения.
        Продолжая просмотр, вы подтверждаете соответствующий статус.
      </p>
      <button @click="confirm" class="confirm-button">Подтверждаю</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HealthcareModal',
  data() {
    return {
      isOpen: false
    }
  },
  mounted() {
    const accepted = localStorage.getItem('healthcareConfirmed')
    this.isOpen = accepted !== 'true'
  },
  methods: {
    confirm() {
      localStorage.setItem('healthcareConfirmed', 'true')
      this.isOpen = false
      this.$emit('confirmed')
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal-content {
  background: white;
  border-radius: 8px;
  padding: 100px 50px;
  width: 90%;
  max-width: 1000px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.modal-title {
  color: #4e9e45;
  margin-bottom: 16px;

  font-size: 42px;
  line-height: 110%;
}

.modal-text {
  color: #3c3c3c;
  margin-bottom: 24px;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
}

.confirm-button {
  background-color: #4e9e45;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 20px;
  cursor: pointer;
  transition: background-color 0.3s;

  width: 240px;
}

.confirm-button:hover {
  background-color: #388e3c;
}

@media (max-width: 768px) {
  .modal-content {
    padding: 20px;
  }
  .modal-title {
    font-size: 28px;
    line-height: 32px;
  }

  .modal-text {
    font-size: 18px;
    line-height: 24px;
  }
}
@media (max-width: 560px) {
  .modal-content {
    padding: 50px 10px;
  }
  .modal-title {
    font-size: 30px;
    line-height: 36px;
  }

  .modal-text {
    font-size: 24px;
    line-height: 32px;
  }
}
</style>
